import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoiceInsights,
  BackendMutationExtractCustomToneOfVoiceInsightsArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE_INSIGHTS } from './schema';

const MUTATION = gql`
  mutation ExtractCustomToneOfVoiceInsights($projectId: ID!, $text: String!, $customTovId: ID!) {
    extractCustomToneOfVoiceInsights(
      projectId: $projectId
      text: $text
      customTovId: $customTovId
    ) {
      ...CustomToneOfVoiceInsights
    }
  }

  ${FRAGMENT_CUSTOM_TONE_OF_VOICE_INSIGHTS}
`;

type Variables = BackendMutationExtractCustomToneOfVoiceInsightsArgs;
type Result = BackendCustomToneOfVoiceInsights[];

export const extractCustomToneOfVoiceInsights = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
